import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { SolutionIntro } from '../components/SolutionIntro';
import { Volumes } from '../components/Volumes';
import { InsidePreview } from '../components/InsidePreview';
import { Bonuses } from '../components/Bonuses';
import { Benefits } from '../components/Benefits';
import { SpecialOffer } from '../components/SpecialOffer';
import { Guarantee } from '../components/Guarantee';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { LastChance } from '../components/LastChance';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
export function Home() {
  return <main className="min-h-screen bg-navy-950 text-white font-inter selection:bg-gold-500/30 selection:text-gold-200" data-id="element-282" data-mp="3kvadcpw1yhx4">
      <Hero data-id="element-283" data-mp="3owcejc9j541q" />
      <PainPoints data-id="element-284" data-mp="3ovub9vog9pkb" />
      <SolutionIntro data-id="element-285" data-mp="3ovarsaj5it46" />
      <Volumes data-id="element-286" data-mp="3oyylb9oljfiw" />
      <InsidePreview data-id="element-287" data-mp="30wroqfcbfvf0" />
      <Bonuses data-id="element-288" data-mp="30xb7tzdpcpum" />
      <Benefits data-id="element-289" data-mp="30vqf8fay7gze" />
      <SpecialOffer data-id="element-290" data-mp="30w9m90z28kyn" />
      <Guarantee data-id="element-291" data-mp="30uozhxizm6bc" />
      <Testimonials data-id="element-292" data-mp="2vxottnq1v5kr" />
      <FAQ data-id="element-293" data-mp="2vxf4818x30fl" />
      <LastChance data-id="element-294" data-mp="2vyq964e3me8a" />
      <Footer data-id="element-295" data-mp="2vy818ai2qbkj" />
      <SalesNotification data-id="element-296" data-mp="2vvluue6x623w" />
    </main>;
}